import {
  DashboardDatedSalesStatisticsState,
  REQUEST_DASHBOARD_DATED_SALES_STATISTICS,
  REQUEST_DASHBOARD_DATED_SALES_STATISTICS_DONE
} from "./types";

const initialState: DashboardDatedSalesStatisticsState = {
  isLoading: true,
  datedSalesStatistics: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_DASHBOARD_DATED_SALES_STATISTICS:
      return {
        isLoading: true,
        datedSalesStatistics: action.payload
      };
    case REQUEST_DASHBOARD_DATED_SALES_STATISTICS_DONE:
      return {
        isLoading: false,
        datedSalesStatistics: action.payload
      };
    default:
      return state;
  }
}
